import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export type ConfirmDialogVariant = 'default' | 'danger';

/** Visual tone for the dialog icon; `auto` maps danger → warning, default → info */
export type ConfirmDialogIcon = 'auto' | 'warning' | 'info' | 'sign-out';

export interface ConfirmDialogOptions {
  title: string;
  message: string;
  subtitle?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: ConfirmDialogVariant;
  icon?: ConfirmDialogIcon;
}

interface ConfirmDialogRequest {
  options: Required<ConfirmDialogOptions>;
  resolve: (confirmed: boolean) => void;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  private requestSubject = new Subject<ConfirmDialogRequest | null>();
  readonly request$ = this.requestSubject.asObservable();

  confirm(options: ConfirmDialogOptions): Observable<boolean> {
    return new Observable<boolean>(subscriber => {
      const request: ConfirmDialogRequest = {
        options: {
          title: options.title,
          message: options.message,
          subtitle: options.subtitle ?? '',
          confirmLabel: options.confirmLabel ?? 'Confirm',
          cancelLabel: options.cancelLabel ?? 'Cancel',
          variant: options.variant ?? 'default',
          icon: options.icon ?? 'auto'
        },
        resolve: (confirmed: boolean) => {
          subscriber.next(confirmed);
          subscriber.complete();
        }
      };
      this.requestSubject.next(request);

      return () => {
        this.requestSubject.next(null);
      };
    });
  }
}
